import {get} from './http'
import {handleSend} from './handleSend'

export const CommonApi = {
  //   *公共接口*

  // 下载文件
  downLoadFile (data) {
    return get('/downFile', data)
  },

  // 获取工作密钥接口（00,0000
  getWorkKeys (data) {
    return handleSend(data, '00', '0000', '0', 'message', true)
  },

  // 登录
  login (data, showType = 'Alert') {
    return handleSend(data, '00', '0001', '0', showType)
  },
  // 登出
  logout (data) {
    return handleSend(data, '00', '0002', '0')
  },
  // 获取树形列表
  getTreeList (TreeCode, operatype, TreeNode) {
    let data = {treeCode: TreeCode, treeNode: TreeNode}
    return handleSend(data, '00', '0003', String(operatype), 'message')
  },
  // 获取下拉列表
  getTableList (CodeTable, instType = '0') {
    let data = {codeTable: CodeTable, insttype: instType}
    return handleSend(data, '00', '0004', '0', false)
  },
  // 获取业务功能列表
  getFunctionList (NodeId) {
    let data = {nodeId: NodeId}
    return handleSend(data, '00', '0005', '0')
  },
  // 修改密码
  handleUpdatePwd (data) {
    return handleSend(data, '00', '0006', '0')
  },
  // 3.1.7.公共下拉框列表接口（00,0007）
  getCommonTableList (ListNo, CoditionList) {
    let data = {listNo: ListNo, codeType: '1', coditionList: CoditionList}
    return handleSend(data, '00', '0007', '0', false)
  },
  // 文件模板导出接口（00,0008
  getFileTemplate (type) {
    let data = {templateType: String(type)}
    return handleSend(data, '00', '0008', '0', false)
  }
}



// WEBPACK FOOTER //
// ./src/request/common_api.js